import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu, X, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import useIsMobile from '../utils/useIsMobile';
import AvvisoAnnulloFipav from './AvvisoAnnulloFipav';

// Cornice dei portali Utenti/Allenatori.
// Desktop: sidebar fissa a sinistra, nascondibile (scelta ricordata nel browser): da nascosta
// la pagina usa tutta la larghezza e il menu si apre a scomparsa dalla barra in alto, come sul telefono.
// Telefono: sempre barra in alto + menu a scomparsa, che si chiude da solo cambiando pagina.
const CHIAVE = 'portale_sidebar_nascosta';
const leggi = () => { try { return localStorage.getItem(CHIAVE) === '1'; } catch { return false; } };

export default function PortaleShell({ Sidebar, children }) {
  const mobile = useIsMobile();
  const [aperto, setAperto] = useState(false);
  const [nascosta, setNascosta] = useState(leggi);
  const loc = useLocation();
  useEffect(() => { setAperto(false); }, [loc.pathname]);
  useEffect(() => { if (!mobile) setAperto(false); }, [mobile]);
  const fissa = (v) => { setNascosta(!v); setAperto(false); try { localStorage.setItem(CHIAVE, v ? '0' : '1'); } catch {} };

  if (!mobile && !nascosta) return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)' }}>
      <Sidebar />
      <button style={s.nascondi} onClick={() => fissa(false)} aria-label="Nascondi il menu" title="Nascondi il menu"><PanelLeftClose size={18} color="var(--text-muted)" /></button>
      <main style={{ marginLeft: '244px', flex: 1, padding: '32px', minHeight: '100vh', color: 'var(--text)', minWidth: 0 }}><div key={loc.pathname} className="pagina-entra"><AvvisoAnnulloFipav />{children}</div></main>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <header className="barra-mobile" style={s.bar}>
        <button style={s.menuBtn} onClick={() => setAperto(true)} aria-label="Apri il menu"><Menu size={22} color="var(--text)" /></button>
        <span style={s.brand}>B-CHEERS ASD</span>
        {!mobile && (
          <button style={s.fissaBtn} onClick={() => fissa(true)} title="Tieni il menu sempre aperto">
            <PanelLeftOpen size={16} /> Menu fisso
          </button>
        )}
      </header>
      {aperto && <>
        <div style={s.velo} onClick={() => setAperto(false)} aria-hidden="true" />
        <Sidebar mobile onClose={() => setAperto(false)} />
        <button style={s.chiudi} onClick={() => setAperto(false)} aria-label="Chiudi il menu"><X size={20} color="#fff" /></button>
      </>}
      <main style={{ padding: mobile ? '16px' : '28px 40px', color: 'var(--text)', overflowX: 'hidden', maxWidth: mobile ? undefined : '1280px', margin: mobile ? undefined : '0 auto' }}>
        <div key={loc.pathname} className="pagina-entra"><AvvisoAnnulloFipav />{children}</div>
      </main>
    </div>
  );
}

const s = {
  bar: { position: 'sticky', top: 0, zIndex: 900, display: 'flex', alignItems: 'center', gap: '10px', height: '56px', padding: '0 12px', background: 'var(--bg)', borderBottom: '1px solid var(--border)' },
  menuBtn: { width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', borderRadius: '10px', cursor: 'pointer', padding: 0 },
  brand: { fontFamily: "'Barlow Condensed'", fontSize: '20px', fontWeight: 800, color: '#F4600C', letterSpacing: '2px' },
  fissaBtn: { marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '6px', background: 'var(--bg-input)', border: '1px solid var(--border2)', borderRadius: '999px', padding: '8px 14px', color: 'var(--text-muted)', fontSize: '13px', fontWeight: 600, cursor: 'pointer' },
  nascondi: { position: 'fixed', top: '30px', left: '214px', zIndex: 150, width: '36px', height: '36px', borderRadius: '50%', border: '1px solid var(--border)', background: 'var(--bg-card)', boxShadow: '0 2px 8px rgba(0,0,0,.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 },
  velo: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000 },
  chiudi: { position: 'fixed', top: '10px', left: '244px', zIndex: 1002, width: '44px', height: '44px', borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 },
};
